import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

interface DocumentPaginationProps {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  onPageChange: (page: number) => void;
}

export default function DocumentPagination({
  currentPage,
  totalPages,
  totalCount,
  onPageChange,
}: DocumentPaginationProps) {
  // 실제 존재하는 페이지만 표시
  const visiblePages = [];
  for (let i = 1; i <= totalPages; i++) {
    visiblePages.push(i);
  }

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex items-center justify-center gap-2">
        {/* 이전 페이지 버튼 */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`w-8 h-8 flex items-center justify-center transition-colors ${
            currentPage === 1
              ? "text-gray-300 cursor-not-allowed"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          <ChevronLeftIcon className="h-5 w-5" />
        </button>

        {/* 페이지 번호들 */}
        {visiblePages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`min-w-[32px] h-8 px-2 flex items-center justify-center text-sm font-medium transition-colors rounded ${
              page === currentPage
                ? "bg-blue-600 text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            {page}
          </button>
        ))}

        {/* 다음 페이지 버튼 */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`w-8 h-8 flex items-center justify-center transition-colors ${
            currentPage === totalPages
              ? "text-gray-300 cursor-not-allowed"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          <ChevronRightIcon className="h-5 w-5" />
        </button>
      </div>

      {/* 총 개수 표시 (페이지가 2개 이상일 때만) */}
      {totalPages >= 2 && (
        <div className="text-xs text-gray-500">
          총 {totalCount}개
        </div>
      )}
    </div>
  );
}